import "./unmark-delivered-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";

import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

import { usePostMarkUndelivered } from "../../hooks/use-post-mark-undelivered.ts";

export const UnmarkDeliveredModal = ({
	onClose,
	isOpen,
	poNumber,
}: {
	onClose: () => void;
	isOpen: boolean;
	poNumber: string;
}) => {
	const { markUndeliveredAsync, isSavingMarkUndelivered } =
		usePostMarkUndelivered();

	const handleConfirm = async () => {
		try {
			await markUndeliveredAsync(poNumber);
			onClose();
		} catch {
			// Error surfaced via the hook's notification.
		}
	};

	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"unmark-delivered-modal"}
			confirmDisabled={isSavingMarkUndelivered}
			confirmText={"Unmark Delivered"}
			confirmVariant={"danger"}
			onCancel={onClose}
			onClose={onClose}
			onConfirm={() => void handleConfirm()}
			showButtonsDisabled={isSavingMarkUndelivered}
			showConfirmationButtons={true}
			title={"Unmark Shipment as Delivered"}
			type={"error"}
			width={282}
		>
			<LoadingSpinner isVisible={isSavingMarkUndelivered} />
			<div className={"unmark-delivered-content"}>
				<SvgIcon className={"unmark-delivered-icon"} icon={alertTriangle} />
				<p>This shipment will no longer be marked as delivered.</p>
			</div>
		</TraxModal>
	);
};
